<template>
    <div :key="fieldAssignmentId">
        <div v-if="!innerIsReview">
            <validation-provider
                v-slot="{ errors }"
                :name="label || 'This'"
                :rules="rules"
                v-bind="providerProps"
                v-show="innerShouldShow"
                :vid="'validate-' + fieldAssignmentId"
            >
                <span class="field-directions" v-if="directions" v-html="directions"></span>
                <v-row justify="center" align="center">
                    <v-col class="shrink color-col">
<!--                        v-mask="mask" TODO:: apply v-mask to the text field-->
                        <v-text-field v-model="color" hide-details class="ma-0 pa-0" solo>
                            <template v-slot:append>
                                <v-menu v-model="menu" top nudge-bottom="105" nudge-left="16" :close-on-content-click="false">
                                    <template v-slot:activator="{ on }">
                                        <div :style="swatchStyle" v-on="on" />
                                    </template>
                                    <v-card>
                                        <v-card-text class="pa-0">
                                            <v-color-picker v-model="color" flat />
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </template>
                        </v-text-field>
                    </v-col>
                </v-row>
            </validation-provider>
        </div>
        <div v-else>
            <type-review
                v-if="extraProps"
                :label="label"
                :directions="directions"
                :should-show="innerShouldShow"
                :show-edit-button="extraProps.editButton"
                :page-number="extraProps.originalPageNumber"
                @goToPage="goToPage($event)"
            >
                <div v-if="innerValue">
                    <span v-html="innerValue"></span>
                </div>
                <div v-else>N/A</div>
            </type-review>
        </div>
    </div>
</template>

<script>
import formMixin from '../formMixin'
import TypeReview from './TypeReview'
// TODO: more validation

export default {
    name: 'TypeColorSelector',
    mixins: [formMixin],
    inheritAttrs: false,
    components: {
        TypeReview
    },
    data: () => {
        return {
            color: '#1976D2',
            mask: '!#XXXXXX',
            menu: false,
        };
    },
    mounted() {
        if( this.innerValue )
            this.color = this.innerValue.hex || this.innerValue;

        this.fieldLoaded(); // signal to the form we are loaded
    },
    watch: {
        color:function(col) {
           this.innerValue = col; // col is a color object
        }
    },
    computed: {
        defaults() {
            return {
                label: this.innerLabel,
                directions: this.directions,
                persistentHint: true
            }
        },
        rules() {
            return (this.enableValidation) ? {
                ...this.validation_settings,
                ...{
                    required:
                        !!this.validation_settings.required &&
                        !!this.innerShouldShow
                }
            } : {}
        },
        swatchStyle() {
            const { color, menu } = this;
            return {
                backgroundColor: color,
                cursor: 'pointer',
                height: '30px',
                width: '30px',
                borderRadius: menu ? '50%' : '4px',
                transition: 'border-radius 200ms ease-in-out',
                border: '1px solid #dddddd'
            }
        }
    }
}
</script>

<style scoped="scss">
    .color-col {
        min-width: 220px;
    }
</style>
